import { CAT, LANG_V2_MAS, MAS } from "../../Data/typeDirs";
import { LanguageCategory } from "./languageCategory";
import { CAT_FORM_SCHEMA, getCategoryMongooseSchema } from "./utils";


/*
{
  _id
  _mastercategory: LanguageData
  _lang_v2: parent id
  type: 'mastercategories'

}
*/
export class Mastercategory extends LanguageCategory{
  constructor(data){
    super(data)
    // this.changed = false
    this.type = Mastercategory.getTypeDir()
    this.childTypes = Mastercategory.getChildTypes()

  }

  toOldLangEntry(){
    let {fullNumber, number, content, _name} = this
    return {
      [`!fullNum`]: fullNumber,
      [`!num`]: number,
      _mask:content,
      _name
    }
  }

  getDisplayText(){
    return `${this.fullNumber} ${this.content}`
  }

  getFormData(){
    return LanguageCategory.getFormData(Mastercategory, this)
  }

  static getFormKeys(){
    return ['number', 'fullNumber', 'content']
  }

  static getFormSchema(){
    return CAT_FORM_SCHEMA
  }

  static getTypeDir(){
    return MAS
  }
  
  static getRelType(){
    return LANG_V2_MAS
  }

  static getParentKey(){
    return false
  }

  static getParentAddress(){
    return false
  }

  getTypeAddress(){
    return LanguageCategory.getTypeAddress(Mastercategory)
  }
  static getTypeAddress(){
    return LanguageCategory.getTypeAddress(Mastercategory)
  }
  static getChildTypes(){
    return [CAT]
  }

  static getFormColWidths(){
    return {
      number:4,
      fullNumber:4,
      content:4
    }
  }

  static constructFromDBData(data){
    return new Mastercategory(super.constructFromDBData(data, Mastercategory.getTypeDir()))
    
  }

  static getMongooseSchema(mongoose, Schema ){
    return super.getMongooseSchema(
      mongoose, 
      Schema, 
      getCategoryMongooseSchema(mongoose, Mastercategory), 
      Mastercategory.getTypeDir()
    )
  }
}